module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/ico_gradient/bronze-ico-gradient-a73aa0cf0493827ee03cfcbc4f9367ab.svg";